module.exports = __webpack_public_path__ + "firasans-book-webfont.7fd683997d3437f4ccb5.woff2";


//////////////////
// WEBPACK FOOTER
// C:/Users/sherr/Desktop/bsf-website/src/assets/fonts/firasans-book-webfont.woff2
// module id = ../../../../../src/assets/fonts/firasans-book-webfont.woff2
// module chunks = 1